
import { HeroSection } from "@/components/home/HeroSection";
import { Footer } from "@/components/Footer";
import AboutSection from "@/components/home/AboutSection";
import ComparisonSection from "@/components/home/ComparisonSection";
import CoreDimensionsSection from "@/components/home/CoreDimensionsSection";
import CTASection from "@/components/home/CTASection";
import { useSearchParams } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";

const HomePage = () => {
  const [searchParams] = useSearchParams();
  const { toast } = useToast();

  if (searchParams.get("type") === "email_confirmation") {
    toast({
      title: "Email verified successfully",
      description: "You can now sign in with your email and password.",
    });
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-gray-50 to-white overflow-hidden">
      <HeroSection />
      <AboutSection />
      <ComparisonSection />
      <CoreDimensionsSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;
